import { Button, ButtonProps, makeStyles } from '@material-ui/core'
import { CSSProperties } from '@material-ui/core/styles/withStyles'
import FileCopyOutlinedIcon from '@material-ui/icons/FileCopyOutlined'

import { PlaybookType } from 'app/types'

import { useCopyHtml, useNotification } from 'hooks'

type Props = {
    playbook: PlaybookType
    disabled?: boolean
    size?: ButtonProps['size']
    variant?: ButtonProps['variant']
    fullWidth?: ButtonProps['fullWidth']
    fontWeight?: CSSProperties['fontWeight']
    hideStartIcon?: boolean
}

const useStyles = makeStyles({
    copyLinkButton: {
        whiteSpace: 'nowrap'
    }
})

export const ExportQG = ({
    playbook,
    disabled = false,
    hideStartIcon,
    size = 'small',
    variant = 'outlined',
    fontWeight = 600,
    fullWidth = false
}: Props) => {
    const classes = useStyles()

    const { showSuccessNotification } = useNotification()

    const { copyHTMLWithPlayButton } = useCopyHtml()

    return (
        <Button
            onClick={() => {
                copyHTMLWithPlayButton(playbook).then(() => {
                    showSuccessNotification('HTML was copied to the clipboard')
                })
            }}
            className={classes.copyLinkButton}
            size={size}
            disabled={disabled}
            color="default"
            variant={variant}
            fullWidth={fullWidth}
            startIcon={hideStartIcon ? null : <FileCopyOutlinedIcon style={{ fontSize: 20 }} />}
        >
            <span style={{ fontWeight }}>COPY HTML</span>
        </Button>
    )
}
